import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, AlertController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { RecurringList } from '../../models/recurringlist';
import { HomePage } from '../home/home';
import { Calender } from '../../models/Calander';
import { User } from '../../models/User';
import { Locals } from '../../models/localmodel';

/**
 * Generated class for the PopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-popover',
  templateUrl: 'popover.html',
})

export class PopoverPage implements OnInit{
seva_id:number;
recurring_array:RecurringList[] = [];
updated_array= new shashwathaArray;
ids_array:any=[];
calendar_details:Calender;
user:User
  constructor(public navCtrl: NavController, public navParams: NavParams,public viewCtrl: ViewController,private restProvider:RestProvider,private alertController:AlertController) {
  }
  ngOnInit(){
    
    this.seva_id = this.navParams.get('id');
    console.log("id passed from billing screen",this.seva_id);
    this.calendar_details = this.navParams.get('calendar');
    console.log("calendar passed from billing screen",this.calendar_details);
    this.user = this.navParams.get('user');
    console.log("user passed from billing screen",this.calendar_details)
    this.getShashwathaSevaUsers();
  }

  //GETTING SHASHWATHA SEVA USERS LIST
  getShashwathaSevaUsers(){
    this.restProvider.getShashwathaSevaUsers().subscribe(
      (result) => {
        
       for(let i=0;i<result.length;i++){
         this.recurring_array.push(result[i])
       }
        console.log("result from the api",this.recurring_array);
      },
      error => {
        console.log("error",error);
      }
    )
  }

  //CANCEL CLICK
  Cancel(){
    let t:any = this.navParams.get('local');
    console.log("local in popover",t)
    let t1= new Locals();
    t1.stype="shashwathaseva";
    this.navCtrl.push(HomePage,{calander:this.calendar_details,user:this.user,sevas:t,local:t1})
  }


  PassSelectedShashwathaSevas(s:RecurringList){
  console.log("seva selected",s);
  if(s.is_active == 1){
    this.ids_array.push(s.id)
  }
  this.updated_array.ids = this.ids_array;
  console.log("array",this.updated_array)
  }
  //SAVE CLICK
  Save(){
    this.restProvider.postShashwathaUsersStatus(this.updated_array).subscribe(
      (res)=>{
          console.log("res",res)
          if(res){
            let alert = this.alertController.create({
                  title: 'Alert',
                  subTitle: 'Saved successfully',
                  buttons: [
                    {
                      text: 'Ok',
                      handler: () => {
                        console.log('Yes clicked');
                      }
                    }
                  ]
                });
                alert.present();
                return;
          }
      },
      error=>{
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Not saved',
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                console.log('Yes clicked');
              }
            }
          ]
        });
        alert.present();
        return;
      }
    )
   // this.navCtrl.push(HomePage);
  
  }

}
export class shashwathaArray{
  ids:any;
}



// WEBPACK FOOTER //
// ./src/pages/popover/popover.ts